import { render, staticRenderFns } from "./CheckStyleEditor.vue?vue&type=template&id=4a8dbd8a&scoped=true&"
import script from "./CheckStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./CheckStyleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CheckStyleEditor.vue?vue&type=style&index=0&id=4a8dbd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8dbd8a",
  null
  
)

export default component.exports